"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.repaymentInsightsAccumulator = exports.profitInsightsAccumulator = void 0;
const utils_1 = __importDefault(require("../../utils"));
const profitInsightsAccumulator = (inputs) => {
    const { cohortTruncatedBaseDate, cohortTruncatedSeriesDate, cohortSeriesAge, } = inputs[0];
    let aggregateTotalVintageCalcValue = 0;
    let aggregateChargedOffVintageCalcValue = 0;
    let aggregateDelinquentVintageCalcValue = 0;
    for (const input of inputs) {
        aggregateTotalVintageCalcValue += input.totalVintageCalcValue;
        aggregateChargedOffVintageCalcValue +=
            input.totalNormalizedIsChargedOffVintageCalcValue;
        aggregateDelinquentVintageCalcValue +=
            input.totalNormalizedIsDelinquentVintageCalcValue;
    }
    return {
        cohortTruncatedBaseDate,
        cohortTruncatedSeriesDate,
        cohortSeriesAge,
        totalVintageCalcValue: aggregateTotalVintageCalcValue,
        totalNormalizedIsChargedOffVintageCalcValue: aggregateChargedOffVintageCalcValue,
        totalNormalizedIsDelinquentVintageCalcValue: aggregateDelinquentVintageCalcValue,
        chargedOffPercentageOfTotalVintageCalcValue: utils_1.default.divideByOrZero(aggregateChargedOffVintageCalcValue, aggregateTotalVintageCalcValue),
        delinquentPercentageOfTotalVintageCalcValue: utils_1.default.divideByOrZero(aggregateDelinquentVintageCalcValue, aggregateTotalVintageCalcValue),
    };
};
exports.profitInsightsAccumulator = profitInsightsAccumulator;
const repaymentInsightsAccumulator = (inputs) => {
    const { cohortTruncatedBaseDate, cohortTruncatedSeriesDate, cohortSeriesAge, } = inputs[0];
    let aggregateTotalRepayments = 0;
    let aggregateReceivableCount = 0;
    let aggregateTotalInitialBalance = null;
    let currentBaseDate = null;
    let currentCumulativeRepayments = 0;
    for (const input of inputs) {
        if (!currentBaseDate || currentBaseDate !== input.cohortBaseDate) {
            aggregateTotalRepayments += currentCumulativeRepayments;
            currentBaseDate = input.cohortBaseDate;
            aggregateReceivableCount += input.originatedReceivablesCount;
            if (input.totalInitialBalanceOfOriginatedReceivables) {
                if (aggregateTotalInitialBalance) {
                    aggregateTotalInitialBalance +=
                        input.totalInitialBalanceOfOriginatedReceivables;
                }
                else {
                    aggregateTotalInitialBalance =
                        input.totalInitialBalanceOfOriginatedReceivables;
                }
            }
        }
        currentCumulativeRepayments = input.cumulativeRepayments;
    }
    aggregateTotalRepayments += currentCumulativeRepayments;
    return {
        cohortTruncatedBaseDate,
        cohortTruncatedSeriesDate,
        cohortSeriesAge,
        totalRepayments: aggregateTotalRepayments,
        averageRepaymentPerReceivable: utils_1.default.divideByOrZero(aggregateTotalRepayments, aggregateReceivableCount),
        percentageRepaidOfTotalInitialBalance: aggregateTotalInitialBalance
            ? utils_1.default.divideByOrZero(aggregateTotalRepayments, aggregateTotalInitialBalance)
            : undefined,
        aggregateReceivableCount,
    };
};
exports.repaymentInsightsAccumulator = repaymentInsightsAccumulator;
//# sourceMappingURL=accumulatorFn.js.map